import React, { type FC } from 'react';

import { titleIcons } from './styles';
import { type TitleIconProps } from './types';

export const TitleIcon: FC<TitleIconProps> = ({ icon }) => {
  if (icon === undefined) {
    return null;
  }

  const ResultIcon = titleIcons[icon];

  return <ResultIcon fontSize="inherit" />;
};
